var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('li',{staticClass:"list-tile",class:{ active: _vm.isActive },style:(_vm.style)},[_vm._t("leading"),_c('div',{staticClass:"content"},[_vm._t("content")],2),_vm._t("trailing")],2)}
var staticRenderFns = []

export { render, staticRenderFns }